import { Grid, List, Skeleton } from '@fs/zion-ui'
import React from 'react'
import { useTranslation } from 'react-i18next'
import SectionCardSkeleton from '../../components/section-card/SectionCardSkeleton'

type Props = {
  isSingleCardPage?: boolean
}

export default function ToolsCardSkeleton({ isSingleCardPage = true }: Props): JSX.Element {
  const [t] = useTranslation()

  return (
    <Grid gutters="nano">
      <SectionCardSkeleton isSingleCardPage={isSingleCardPage} heading={t('tree-person.tools.label')}>
        <List>
          <Skeleton.ListItem dense hasIcon />
          <Skeleton.ListItem dense hasIcon />
          <Skeleton.ListItem dense hasIcon />
          <Skeleton.ListItem dense hasIcon />
          <Skeleton.ListItem dense hasIcon />
          <Skeleton.ListItem dense hasIcon />
          <Skeleton.ListItem dense hasIcon />
          <Skeleton.ListItem dense hasIcon />
        </List>
      </SectionCardSkeleton>
    </Grid>
  )
}
